import { tv } from '@/common/theme/tv.config';

export const styles = {
  host: tv({
    base: 'overflow-hidden border-0',
    variants: {
      error: { true: 'border border-systemError' },
      checked: { true: 'bg-accentPrimary10' },
    },
  }),
};
